import * as PropTypes from "prop-types";
import styled from "styled-components";
import ActionButton from "basicComponents/ActionButton/ActionButton";
import PlusIcon from "images/PlusIcon";

export default function IconActionButton(props) {
  const localIcon = props.icon || (
    <PlusIcon enableSmallMarginTop={props.enableSmallMarginTop} />
  );
  const showIcon = !props.noIcon;

  return (
    <ActionButton
      id={props.id}
      customHeight={props.customHeight}
      customWidth={props.customWidth}
      fullWidth={props.fullWidth}
      customBorderRadius={props.customBorderRadius}
      {...props}
    >
      <Content>
        <TextContent textAlignLeft={props.textAlignLeft}>
          {props.children}
        </TextContent>
        <IconWrapper iconScale={props.customIconScale || 1}>
          {showIcon && localIcon}
        </IconWrapper>
      </Content>
    </ActionButton>
  );
}

IconActionButton.propTypes = {
  noIcon: PropTypes.bool,
  icon: PropTypes.node,
  children: PropTypes.any,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  equalPadding: PropTypes.bool,
  customHeight: PropTypes.string,
  customWidth: PropTypes.string,
  listenKey: PropTypes.string,
  enableSmallMarginTop: PropTypes.bool,
  id: PropTypes.string,
  customIconScale: PropTypes.number,
  textAlignLeft: PropTypes.bool,
  customBorderRadius: PropTypes.string,
};

IconActionButton.propTypes = {};

const TextContent = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: ${({ textAlignLeft }) => (textAlignLeft ? "left" : "center")};
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const IconWrapper = styled.div`
  transform: scale(${({ iconScale }) => iconScale});
  padding-left: 0.5rem;
  width: 20px;
`;
